var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            _vm._s(_vm.$t("__.Crud.resgates.list_vue_html.resgateRecompensas"))
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("__.Crud.resgates.list_vue_html.resgateRecompensas")
                )
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("__.Crud.resgates.list_vue_html.cadastradas"))
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          ref: "gridcomponent",
          attrs: {
            columns: _vm.gridColumns,
            extraActions: _vm.extraActions,
            data: _vm.gridData,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            startFilterKey: _vm.startFilterKey,
            tituloPagina: "campanhaRecompensaResgate",
            total: _vm.total,
            removeItemIcon: "fa-exclamation-circle",
            showEditItem: false,
          },
          on: {
            "change-filter-key": _vm.onChangeFilterKey,
            "change-page": _vm.onChangePage,
            "change-sort": _vm.onChangeSort,
            "create-item": _vm.onCreateItem,
            "gerar-impressao": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 2
            },
            "gerar-pdf": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 1
            },
            "gerar-xls": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 0
            },
            "remove-item": _vm.onRemoveItem,
            "extra-action": _vm.onExtraAction,
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "filtro-lista" }, [
              _c(
                "button",
                {
                  staticClass: "filtro-avancado-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.isHidden = !_vm.isHidden
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "fa fa-caret-down" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isHidden,
                      expression: "isHidden",
                    },
                  ],
                  staticClass: "drop-lista",
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "novalidate" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.load($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataInicial" },
                                },
                                [_vm._v("Data Inicial")]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  pickTime: true,
                                  value: _vm.dataFilter1,
                                  id: "dataFilter1",
                                  name: "dataFilter1",
                                },
                                model: {
                                  value: _vm.dataFilter1,
                                  callback: function ($$v) {
                                    _vm.dataFilter1 = $$v
                                  },
                                  expression: "dataFilter1",
                                },
                              }),
                              _vm._v(" "),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "__.Components.parent.venda.listOrcamento_vue_html.ate"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  pickTime: true,
                                  id: "dataFilter2",
                                  name: "dataFilter2",
                                },
                                model: {
                                  value: _vm.dataFilter2,
                                  callback: function ($$v) {
                                    _vm.dataFilter2 = $$v
                                  },
                                  expression: "dataFilter2",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "clienteId" },
                                },
                                [_vm._v("Cliente")]
                              ),
                              _vm._v(" "),
                              _c("search-combo-component", {
                                attrs: {
                                  id: "clienteId",
                                  name: "clienteId",
                                  service: "Cliente",
                                  propDescription: "nome",
                                  advancedSearchCampos: [
                                    { campo: "text", descricao: "Nome" },
                                  ],
                                },
                                model: {
                                  value: _vm.clienteId,
                                  callback: function ($$v) {
                                    _vm.clienteId = $$v
                                  },
                                  expression: "clienteId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "botao-filtrar",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("__.Crud.filtrar")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }